import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/courses/:courseId/enrollments/request/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const request = {
  post: apiPathFunc(pathBase),
} as const;
